jQuery(document).ready(function() { 
	
    jQuery('iframe').load(function() { 
	    
      Foundation.reInit( jQuery( '.news-feed' ));
      
      var post_height = jQuery('.news-row').height();
      
      var post_height = parseInt( post_height );
      
      var post_height = post_height;
      
     var css = "calc(100% - " + post_height + "px)";
      
      jQuery('.news-timeline').css('height', css);
      
    });
    
});